import { 
    fixedHeader, 
    mobileMenu, 
    inViewport, 
    initializeUserway,
    addScrollToTopEvent,
    setupScrollTo,
    handleSectionScrollFromQuery
} from './parts/helpers';

document.addEventListener('load', handleSectionScrollFromQuery());

const init = () => {    
    
    // Fixed headar
    fixedHeader();

    window.document.addEventListener('scroll', () => {
        fixedHeader();
    });

    // Mobile menu click
    mobileMenu();

    // Scroll to section
    setupScrollTo();

    // Scroll to top
    addScrollToTopEvent();
   
}

window.document.addEventListener('DOMContentLoaded', init);


